import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ExternalLinks } from 'global/externalLinks';
import { Box, Link } from '@clariness/clarikit-react';

export const AuthPageLayoutInfoLinks: React.FC = () => {
  return (
    <Box
      as="nav"
      aria-label="Legal information"
      display="flex"
      alignItems="stretch"
      gap="15px"
      style={{ marginTop: '35px' }}
    >
      <Link
        url={ExternalLinks.PRIVACY_POLICY}
        external
        color="color-gray-variant-1"
      >
        <FormattedMessage
          id="is.auth_page.privacy_link"
          defaultMessage="Privacy"
        />
      </Link>

      <Box
        as="span"
        aria-hidden="true"
        width="1px"
        backgroundColor="color-gray-variant-2"
      />

      <Link url={ExternalLinks.IMPRINT} external color="color-gray-variant-1">
        <FormattedMessage
          id="is.auth_page.imprint_link"
          defaultMessage="Imprint"
        />
      </Link>
    </Box>
  );
};
